(function () {
  var DESKTOP = window.matchMedia('(min-width: 799px)');

  /* ---- PDP desktop: move the description under the buttons ---- */
  function placeDescription() {
    var details = document.querySelector('.product__details--product-page');
    if (!details) return;
    var desc = details.querySelector('.product-block--description');
    var anchor = details.querySelector('.product-block--form .product_form');
    if (!desc || !anchor) return;
    if (DESKTOP.matches) {
      if (!desc.__bleuOrigin) { desc.__bleuOrigin = { parent: desc.parentNode, next: desc.nextSibling }; }
      if (anchor.nextElementSibling !== desc) { anchor.insertAdjacentElement('afterend', desc); }
      desc.style.marginTop = '48px';
    } else if (desc.__bleuOrigin) {
      var o = desc.__bleuOrigin;
      if (o.parent && (o.next === null || o.parent.contains(o.next))) { o.parent.insertBefore(desc, o.next); }
      desc.style.marginTop = '';
    }
  }

  /* ---- PDP: move the Size Guide link next to the Size label (all screen sizes) ---- */
  function placeSizeGuide() {
    var details = document.querySelector('.product__details--product-page');
    if (!details) return;
    var guide = details.querySelector('.external-btn');
    if (!guide || !guide.querySelector('#pdp-myBtn1')) return;
    var titles = details.querySelectorAll('.product_form .option_title');
    var sizeTitle = null;
    for (var i = 0; i < titles.length; i++) {
      var label = (titles[i].firstChild ? titles[i].firstChild.textContent : titles[i].textContent) || '';
      if (/^\s*size\s*$/i.test(label)) { sizeTitle = titles[i]; break; }
    }
    if (sizeTitle && guide.parentNode !== sizeTitle) { sizeTitle.appendChild(guide); }
  }

  /* ---- PDP Add to Cart: show price (with strikethrough compare-at) and stock line ---- */
  function fmt(t) { return (t || '').replace(/\s+/g, ' ').trim().replace(/\.00$/, ''); }

  function initCTA() {
    var btn = document.querySelector('.product__details--product-page .purchase-details__buttons .add_to_cart');
    if (!btn || btn.__bleuCTA) return;
    btn.__bleuCTA = true;

    var price = document.createElement('bleu-cta-price');
    price.className = 'bleu-cta-price';
    var status = document.createElement('bleu-cta-status');
    status.className = 'bleu-cta-status';
    status.innerHTML = '<i class="bleu-cta-dot"></i><em style="font-style:normal"><b>In stock</b> : Ready to ship</em>';
    btn.appendChild(price);
    btn.appendChild(status);

    function update() {
      var cur = document.querySelector('.product-block--price .price .money');
      var cmp = document.querySelector('.product-block--price .compare-at-price .money');
      var label = btn.querySelector('.text');
      var available = !btn.disabled && label && /add to cart/i.test(label.textContent);
      var c = cur ? fmt(cur.textContent) : '';
      var o = cmp ? fmt(cmp.textContent) : '';
      price.innerHTML = (o && o !== c ? '<s>' + o + '</s>' : '') + c;
      price.classList.toggle('is-on', !!(available && c));
      status.classList.toggle('is-on', !!available);
    }

    update();
    if (window.MutationObserver) {
      var mo = new MutationObserver(update);
      var priceBlock = document.querySelector('.product-block--price');
      if (priceBlock) { mo.observe(priceBlock, { childList: true, subtree: true, characterData: true }); }
      var label = btn.querySelector('.text');
      if (label) { mo.observe(label, { childList: true, characterData: true, subtree: true }); }
      mo.observe(btn, { attributes: true, attributeFilter: ['disabled', 'class'] });
    }
  }

  /* ---- PDP: See More / See Less toggle for the description.
     One document-level capturing listener (bound once), so it works after InstantClick page changes
     and cannot double-fire with any older handler. ---- */
  if (!window.__bleuReadMore) {
    window.__bleuReadMore = true;
    document.addEventListener('click', function (e) {
      var link = e.target && e.target.closest ? e.target.closest('a.readmore') : null;
      if (!link) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
      var scope = link.parentNode;
      var desc = scope && scope.querySelector('.product-description');
      if (!desc) { desc = document.querySelector('.product-description.rte'); }
      if (!desc) return;
      var open = desc.getAttribute('data-bleu-open') === '1';
      if (open) {
        desc.removeAttribute('data-bleu-open');
        desc.style.height = '';
        link.textContent = 'See More';
      } else {
        desc.setAttribute('data-bleu-open', '1');
        desc.style.height = 'auto';
        link.textContent = 'See Less';
      }
    }, true);
  }

  function run() { placeDescription(); placeSizeGuide(); initCTA(); }

  function init() {
    run();
    if (window.InstantClick && typeof window.InstantClick.on === 'function') {
      window.InstantClick.on('change', run);
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  if (DESKTOP.addEventListener) { DESKTOP.addEventListener('change', placeDescription); } else if (DESKTOP.addListener) { DESKTOP.addListener(placeDescription); }
  window.addEventListener('resize', placeDescription);
})();
